<main>
  <p-toolbar styleClass="mb-4 gap-2 flex gap-2">
    <ng-template pTemplate="left">
      <div class="flex gap-4">
        <p-button (click)="showDialog()" label="Alta tarjeta" />
        <p-dialog
          header="Alta tarjeta"
          [modal]="true"
          [(visible)]="visible"
          [style]="{ width: '25rem' }"
        >
          <span class="p-text-secondary block mb-8"
            >Añade el código de barras con el lector y el importe a
            recargar.</span
          >
          <div class="flex items-center gap-4 mb-4">
            <label for="code" class="font-semibold w-24"
              >Código de barras</label
            >
            <input
              pInputText
              id="code"
              class="flex-auto"
              autocomplete="off"
              [(ngModel)]="card.code"
            />
          </div>
          <div class="flex items-center gap-4 mb-8">
            <label for="cantidad" class="font-semibold w-24">Importe €</label>
            <input
              pInputText
              id="cantidad"
              class="flex-auto"
              autocomplete="off"
              [(ngModel)]="card.points"
            />
          </div>
          <div class="flex justify-end gap-2">
            <p-button
              label="Cancel"
              severity="secondary"
              (click)="visible = false"
            />
            <p-button label="Save" (click)="saveCard()" />
          </div>
        </p-dialog>
      </div>
    </ng-template>
  </p-toolbar>
  <p-table
    #dt2
    [loading]="loading"
    [value]="cards"
    [globalFilterFields]="['name', 'default_code', 'barcode']"
    dataKey="default_code"
    sortField="name"
    [sortOrder]="1"
    [tableStyle]="{ 'min-width': '50rem' }"
  >
    <ng-template #header>
      <tr>
        <th>Código de barras</th>
        <th>Importe</th>
      </tr>
    </ng-template>
    <ng-template #body let-card>
      <tr>
        <td>{{ card.code }}</td>
        <td>{{ card.points | currency: 'EUR' }}</td>
      </tr>
    </ng-template>
  </p-table>
  <p-toast></p-toast>
</main>
